import { styled } from '@material-ui/core';

const ButtonBase = styled('button')(() => ({
  minHeight: '40px',
  minWidth: '64px',
  cursor: 'pointer',
  margin: 0,
  borderRadius: '54px',
  textAlign: 'center',
  padding: '10px 20px',
  verticalAlign: 'middle',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 250ms',
  boxSizing: 'border-box',
  lineHeight: '20px',
  fontFamily: 'inherit',
  fontSize: '14px',
  outline: 'none',
  '&:disabled': {
    pointerEvents: 'none',
    cursor: 'default',
  },
}));

export default ButtonBase;
